var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"options":_vm.branchOpt,"reduce":opt => opt.id,"clearable":false},on:{"input":_vm.setBranch},model:{value:(_vm.branch_id),callback:function ($$v) {_vm.branch_id=$$v},expression:"branch_id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }